import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "kn-page kn-data-preparation" }
const _hoisted_2 = { class: "p-col-4" }
const _hoisted_3 = {
  key: 0,
  class: "p-float-label p-field p-ml-2 kn-flex"
}
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { class: "arrow-button-container" }
const _hoisted_6 = { class: "kn-page-content p-grid p-m-0 managerDetail" }
const _hoisted_7 = { class: "info-container" }
const _hoisted_8 = { class: "original-dataset" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-database p-mr-2" }, null, -1)
const _hoisted_10 = { class: "titleContainer" }
const _hoisted_11 = { class: "kn-truncated" }
const _hoisted_12 = { class: "p-text-uppercase kn-list-item transformationSidebarElement" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { class: "aliasAndType p-ml-2" }
const _hoisted_17 = { class: "kn-list-item-text-secondary kn-truncated roleType" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { class: "p-ml-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnCalculatedField = _resolveComponent("KnCalculatedField")
  const _component_DataPreparationDialog = _resolveComponent("DataPreparationDialog")
  const _component_DataPreparationSaveDialog = _resolveComponent("DataPreparationSaveDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Badge = _resolveComponent("Badge")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_KnCalculatedField, {
      visibility: _ctx.showCFDialog,
      "onUpdate:visibility": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCFDialog = $event)),
      onSave: _ctx.saveCFDialog,
      onCancel: _ctx.cancelCFDialog,
      fields: _ctx.columns,
      descriptor: _ctx.cfDescriptor,
      propCalcFieldFunctions: _ctx.cfDescriptor.availableFunctions,
      readOnly: _ctx.readOnly,
      "onUpdate:readOnly": _ctx.updateReadOnly,
      template: _ctx.selectedTransformation,
      "onUpdate:template": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTransformation = $event)),
      valid: _ctx.cfType !== ''
    }, {
      additionalInputs: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          (_ctx.cfDescriptor.availableTypes)
            ? (_openBlock(), _createBlock("span", _hoisted_3, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.cfType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cfType = $event)),
                  options: _ctx.cfDescriptor.availableTypes,
                  disabled: _ctx.readOnly,
                  class: ["kn-material-input", {
                                'p-invalid': !_ctx.cfType
                            }],
                  optionLabel: "label",
                  optionValue: "code"
                }, null, 8, ["modelValue", "options", "disabled", "class"]),
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('components.knCalculatedField.type')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visibility", "onSave", "onCancel", "fields", "descriptor", "propCalcFieldFunctions", "readOnly", "onUpdate:readOnly", "template", "valid"]),
    _createVNode(_component_DataPreparationDialog, {
      transformation: _ctx.selectedTransformation,
      "onUpdate:transformation": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTransformation = $event)),
      onSendTransformation: _ctx.handleTransformation,
      columns: _ctx.columns,
      col: _ctx.col,
      "onUpdate:col": _cache[5] || (_cache[5] = ($event: any) => (_ctx.col = $event)),
      readOnly: _ctx.readOnly,
      "onUpdate:readOnly": _ctx.updateReadOnly
    }, null, 8, ["transformation", "onSendTransformation", "columns", "col", "readOnly", "onUpdate:readOnly"]),
    _createVNode(_component_DataPreparationSaveDialog, {
      visibility: _ctx.showSaveDialog,
      "onUpdate:visibility": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSaveDialog = $event)),
      originalDataset: _ctx.dataset,
      config: _ctx.dataset.config,
      columns: _ctx.columns,
      instanceId: _ctx.instanceId,
      "onUpdate:instanceId": _ctx.updateInstanceId,
      processId: _ctx.processId,
      "onUpdate:processId": _ctx.updateprocessId,
      preparedDsMeta: _ctx.preparedDsMeta
    }, null, 8, ["visibility", "originalDataset", "config", "columns", "instanceId", "onUpdate:instanceId", "processId", "onUpdate:processId", "preparedDsMeta"]),
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.label')) + " (" + _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.originalDataset')) + ": " + _toDisplayString(_ctx.dataset.name) + ")", 1)
      ]),
      end: _withCtx(() => [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-refresh",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.refreshOriginalDataset,
          disabled: _ctx.loading > 0
        }, null, 8, ["onClick", "disabled"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.refresh'),
            void 0,
            { bottom: true }
          ]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.saveDataset,
          disabled: _ctx.loading > 0
        }, null, 8, ["onClick", "disabled"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.save'),
            void 0,
            { bottom: true }
          ]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeTemplate()))
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('common.close'),
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0 toolbarCustomConfig" }, {
      start: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getMenuForToolbar(), (menu, index) => {
          return (_openBlock(), _createBlock(_Fragment, { key: index }, [
            (menu !== 'divider')
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: _ctx.descriptor.css.buttonClassHeader,
                  onClick: ($event: any) => (_ctx.callFunction(menu)),
                  disabled: _ctx.calculateDisabledProperty(menu)
                }, {
                  default: _withCtx(() => [
                    (menu.icon.class)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          class: menu.icon.class
                        }, _toDisplayString(menu.icon.name), 3))
                      : (_openBlock(), _createBlock("i", {
                          key: 1,
                          class: menu.icon
                        }, null, 2))
                  ]),
                  _: 2
                }, 1032, ["class", "onClick", "disabled"])), [
                  [
                    _directive_tooltip,
                    _ctx.$t(menu.label),
                    void 0,
                    { bottom: true }
                  ]
                ])
              : (_openBlock(), _createBlock(_component_Divider, {
                  key: 1,
                  layout: "vertical"
                }))
          ], 64))
        }), 128))
      ]),
      end: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            icon: "pi pi-arrow-left",
            class: _ctx.descriptor.css.buttonClassHeader,
            style: {"overflow":"visible"},
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleSidebarVisibility()))
          }, null, 8, ["class"]),
          (_ctx.dataset.config && _ctx.dataset.config.transformations && _ctx.dataset.config.transformations.length > 0)
            ? (_openBlock(), _createBlock(_component_Badge, {
                key: 0,
                class: "arrow-badge",
                value: _ctx.dataset.config && _ctx.dataset.config.transformations && _ctx.dataset.config.transformations.length
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.loading > 0)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.progressMode === 'indeterminate')
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                class: "kn-progress-bar",
                mode: _ctx.progressMode,
                value: _ctx.getProgressValue()
              }, null, 8, ["mode", "value"]))
            : (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 1,
                class: "kn-progress-bar",
                value: _ctx.getProgressValue()
              }, null, 8, ["value"]))
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_Divider, { class: "kn-divider dividerCustomConfig" }),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Sidebar, {
        visible: _ctx.visibleRight,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.visibleRight = $event)),
        position: "right",
        class: "kn-data-preparation-sidenav"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.originalDataset')), 1),
              _createTextVNode(": " + _toDisplayString(_ctx.dataset.label), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("h4", _hoisted_11, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.label')), 1)
          ]),
          _createVNode(_component_Divider, { class: "p-m-0 p-p-0 dividerCustomConfig" }),
          _createVNode(_component_Listbox, {
            class: "kn-list kn-flex kn-list-no-border-right",
            options: _ctx.reverseTransformations(),
            optionLabel: "type"
          }, {
            option: _withCtx((slotProps) => [
              _createVNode("div", _hoisted_12, [
                (slotProps.option.type != 'calculatedField')
                  ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(slotProps.option.type) + " - " + _toDisplayString(slotProps.option.parameters[0].columns[0]), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(slotProps.option.type) + " - " + _toDisplayString(slotProps.option.parameters[0].colName), 1)),
                _createVNode("div", null, [
                  (slotProps.option.type != 'trim' && slotProps.option.type != 'drop')
                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "fas fa-eye",
                        class: _ctx.descriptor.css.buttonClassHeader,
                        onClick: ($event: any) => (_ctx.openTransformationDetail(slotProps.option))
                      }, null, 8, ["class", "onClick"])), [
                        [_directive_tooltip, _ctx.$t('common.preview')]
                      ])
                    : _createCommentVNode("", true),
                  (slotProps.index == 0)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "p-jc-end pi pi-trash",
                        class: _ctx.descriptor.css.buttonClassHeader,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteTransformation())),
                        disabled: _ctx.loading > 0
                      }, null, 8, ["class", "disabled"])), [
                        [_directive_tooltip, _ctx.$t('common.delete')]
                      ])
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_DataTable, {
        ref: "dt",
        value: _ctx.datasetData,
        class: "p-datatable-sm kn-table data-prep-table",
        dataKey: "id",
        paginator: _ctx.datasetData.length > 20,
        rows: 20,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        breakpoint: "960px",
        currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
        loading: _ctx.loading > 0,
        resizableColumns: true,
        columnResizeMode: "expand",
        showGridlines: "",
        responsiveLayout: "scroll",
        scrollable: true,
        scrollDirection: "both"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col, colIndex) => {
            return (_openBlock(), _createBlock(_component_Column, {
              field: col.header,
              key: colIndex,
              style: { width: '200px' }
            }, {
              header: _withCtx(() => [
                (col.fieldType)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: _ctx.descriptor.css.buttonClassHeader,
                      onClick: ($event: any) => (_ctx.toggle($event, 'opType-' + colIndex))
                    }, {
                      default: _withCtx(() => [
                        (_ctx.descriptor.roles.filter((x) => x.code === col.fieldType)[0].icon.class)
                          ? (_openBlock(), _createBlock("span", {
                              key: 0,
                              class: _ctx.descriptor.roles.filter((x) => x.code === col.fieldType)[0].icon.class
                            }, _toDisplayString(_ctx.descriptor.roles.filter((x) => x.code === col.fieldType)[0].icon.name), 3))
                          : (_openBlock(), _createBlock("i", {
                              key: 1,
                              class: _ctx.descriptor.roles.filter((x) => x.code === col.fieldType)[0].icon
                            }, null, 2))
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_OverlayPanel, {
                  ref: 'opType-' + colIndex,
                  popup: true
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_15, [
                      _createVNode(_component_Dropdown, {
                        modelValue: col.fieldType,
                        "onUpdate:modelValue": ($event: any) => (col.fieldType = $event),
                        options: _ctx.translateRoles(),
                        optionLabel: "label",
                        optionValue: "code",
                        class: "kn-material-input"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                    ])
                  ]),
                  _: 2
                }, 1536),
                _createVNode("div", _hoisted_16, [
                  (col.editing)
                    ? _withDirectives((_openBlock(), _createBlock("input", {
                        key: 0,
                        class: "kn-input-text-sm",
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => (col.fieldAlias = $event),
                        onBlur: ($event: any) => (_ctx.changeAlias(col)),
                        onKeydown: _withKeys(($event: any) => (_ctx.changeAlias(col)), ["enter"])
                      }, null, 40, ["onUpdate:modelValue", "onBlur", "onKeydown"])), [
                        [_vModelText, col.fieldAlias]
                      ])
                    : (_openBlock(), _createBlock("span", {
                        key: 1,
                        class: "kn-clickable",
                        onClick: ($event: any) => (_ctx.changeAlias(col))
                      }, _toDisplayString(col.fieldAlias), 9, ["onClick"])),
                  _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t(_ctx.removePrefixFromType(col.Type))), 1)
                ]),
                _createVNode(_component_Button, {
                  icon: "pi pi-ellipsis-v",
                  class: _ctx.descriptor.css.buttonClassHeader,
                  onClick: ($event: any) => (_ctx.toggle($event, 'trOpType-' + colIndex))
                }, null, 8, ["class", "onClick"]),
                _createVNode(_component_Menu, {
                  model: _ctx.getTransformationsMenu(col),
                  ref: 'trOpType-' + colIndex,
                  popup: true
                }, {
                  item: _withCtx(({item}) => [
                    _createVNode("span", {
                      class: ['p-menuitem-link', 'toolbarCustomConfig', _ctx.descriptor.css.buttonClassHeader],
                      onClick: ($event: any) => (_ctx.callFunction(item, col))
                    }, [
                      (item.icon.class)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            class: [item.icon.class, "menu-icon"]
                          }, _toDisplayString(item.icon.name), 3))
                        : (_openBlock(), _createBlock("i", {
                            key: 1,
                            class: item.icon
                          }, null, 2)),
                      _hoisted_18,
                      _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(item.label)), 1)
                    ], 10, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["model"])
              ]),
              body: _withCtx(({data}) => [
                (col.Type.toLowerCase().includes('time'))
                  ? (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(_ctx.getFormattedDate(data[col.header], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })), 1))
                  : (col.Type.toLowerCase().includes('date'))
                    ? (_openBlock(), _createBlock("span", _hoisted_21, _toDisplayString(_ctx.getFormattedDate(data[col.header], { year: 'numeric', month: '2-digit', day: '2-digit' })), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(data[col.header]), 1))
              ]),
              _: 2
            }, 1032, ["field"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "paginator", "currentPageReportTemplate", "loading"])
    ])
  ]))
}